import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { AuthentificationGuardWithForcedLoginService } from './authentification-guard-login.service';
import { AuthentificationService } from './authentification.service';
import { WebsocketService } from './websocket/websocket.service';

@NgModule({
  imports: [],
  providers: [
    AuthentificationService,
    AuthentificationGuardWithForcedLoginService,
  ],
})
export class AuthentificationModule {
  static forRoot(): ModuleWithProviders<AuthentificationModule> {
    return {
      ngModule: AuthentificationModule,
      providers: [WebsocketService],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AuthentificationModule) {
    if (parentModule) {
      throw new Error(
        'AuthentificationModule is already loaded. Import it in the AppModule only',
      );
    }
  }
}
